import Carousel from 'react-bootstrap/Carousel';
import { useState } from 'react';
import './CustomCarousel.css'

const NeetChampionBanner = (props) => {
    let {stream} = props?.profileData;
    stream = stream.toLowerCase()

    //const [imgCount, setImgCount] = useState({sof:2, som:3, soe:3})
    const [imgCount, setImgCount] = useState(
    props?.profileData?.exam_type === 'AKTHE'
        ? { sof: 2, som: 1, soe: 1 } 
        : { sof: 4, som: 2, soe: 2 }
    );
    const [index, setIndex] = useState(0);
    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <div className='mb-5 mt-4'>
        <Carousel activeIndex={index} onSelect={handleSelect}>
            {new Array(imgCount[stream]).fill(1).map((v, i) => {
                return(
            <Carousel.Item key={i}>
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="" aria-label="Slide 1" className="active" aria-current="true"></button>
                    <button type="button" data-bs-target="" aria-label="Slide 2" aria-current="false"></button>
                </div>
                <img
                    src={
                    props?.profileData.exam_type === 'AKTHE'
                        ? `https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/dashboard/result/AKTHE/${stream}-desktop-${i+1}.png`
                        : `https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/dashboard/result/${stream}-desktop-${i+1}.png`
                    }
                    className="img-fluid d-sm-block d-none"
                    alt="neet-champions-banner"
                />
                <img
                    src={
                    props?.profileData.exam_type === 'AKTHE'
                        ? `https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/dashboard/result/AKTHE/${stream}-mobile-${i+1}.png`
                        : `https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/dashboard/result/${stream}-mobile-${i+1}.png`
                    }
                    className="img-fluid d-block d-sm-none img_mobile"
                    alt="neet-champions-banner"
                />
                </Carousel.Item>

            )})}
        </Carousel>
        </div>
    );
};

export default NeetChampionBanner;